import { Admin, Role } from "types/admin";
import { create, useStore } from "zustand";

interface AdminsStore {
  admins: Admin[];
  isAdminsLoading: boolean;
  currentRole: Role | null;
}

export const adminsStore = create<AdminsStore>((_set) => ({
  admins: [],
  isAdminsLoading: false,
  currentRole: null,
}));

export const useAdminsStore = () => useStore(adminsStore);
